module.exports = __webpack_public_path__ + "img/ic-union-pay-no-color.d73cb4cc.svg";